export const TRANSLATIONS_FR_SETTINGS_MICROSOFT = {
  "settings.microsoft.connect_button": "Connecter Microsoft",
  "settings.microsoft.connecting": "Connexion...",
  "settings.microsoft.connected_success": "Connexion Microsoft terminee.",
  "settings.microsoft.loading_status": "Chargement du statut Microsoft...",
  "settings.microsoft.no_accounts": "Aucun compte Microsoft connecte.",
  "settings.microsoft.selected_account": "Compte selectionne",
  "settings.microsoft.select_account": "Selectionnez un compte",
  "settings.microsoft.unnamed_account": "Compte sans nom",
  "settings.microsoft.email_unavailable": "E-mail indisponible",
  "settings.microsoft.invalid_account": "Identite de compte invalide. Actions desactivees.",
  "settings.microsoft.malformed_status": "La reponse de statut Microsoft est invalide. Actions desactivees.",
  "settings.microsoft.status_error": "Impossible de charger le statut Microsoft.",
  "settings.microsoft.connect_error": "Impossible de terminer l'authentification Microsoft.",
  "settings.microsoft.disconnect_error": "Impossible de deconnecter le compte Microsoft.",
  "settings.microsoft.default_error": "Impossible de definir le compte Microsoft par defaut.",
  "settings.microsoft.reauthorize_error": "Impossible de reautoriser le compte Microsoft.",
  "settings.microsoft.popup_blocked": "Le navigateur a bloque la fenetre popup. Autorisez les popups pour continuer.",
  "settings.microsoft.sync_period_saved": "Date de debut de synchronisation enregistree.",
  "settings.microsoft.sync_period_error": "Impossible d'enregistrer la date de debut de synchronisation.",
  "settings.microsoft.sync_period_integer_error": "Selectionnez une date valide.",
  "settings.microsoft.sync_period_range_error": "Selectionnez une date entre il y a 365 jours et aujourd'hui.",
  "settings.microsoft.save_sync_period": "Enregistrer la date",
  "settings.microsoft.make_default": "Definir par defaut",
  "settings.microsoft.reauthorize": "Reautoriser",
  "settings.microsoft.disconnect": "Deconnecter",
  "settings.microsoft.oauth_processing": "Traitement de l'authentification Microsoft...",
  "settings.microsoft.mail_preview_title": "Apercu des e-mails",
  "settings.microsoft.drive_preview_title": "Apercu Drive",
  "settings.microsoft.sharepoint_preview_title": "Apercu SharePoint",
  "settings.microsoft.no_preview_items": "Aucun element a afficher.",
  "settings.microsoft.table.account": "Compte",
  "settings.microsoft.table.status": "Statut",
  "settings.microsoft.table.sync_period": "Synchroniser depuis",
  "settings.microsoft.table.default": "Defaut",
  "settings.microsoft.table.actions": "Actions",
  "settings.microsoft.connected": "Connecte",
  "settings.microsoft.connection_status_title": "Statut de connexion",
  "settings.microsoft.sync_process_title": "Synchronisation du compte",
  "settings.microsoft.sync.mail_sync_status": "Statut sync email",
  "settings.microsoft.sync.drive_sync_status": "Statut sync drive",
  "settings.microsoft.sync.last_mail_sync_at": "Derniere sync email",
  "settings.microsoft.sync.last_drive_sync_at": "Derniere sync drive",
  "settings.microsoft.sync.last_read_email_date": "Date du dernier e-mail synchronisé",
  "settings.microsoft.sync.last_sync_date": "Dernière synchronisation",
  "settings.microsoft.sync.emails_processed": "E-mails traités",
  "settings.microsoft.sync.period": "Période de synchronisation",
  "settings.microsoft.sync.not_set": "Non défini",
  "settings.microsoft.sync.all": "Tous",
  "settings.microsoft.diagnostics_title": "Diagnostics",
  "settings.microsoft.audit_title": "Audit et securite",
  "settings.microsoft.manage_access_link": "Gerer les permissions du compte Microsoft",
  "settings.microsoft.privacy_policy": "Politique de confidentialite",
  "settings.microsoft.terms_of_service": "Conditions d'utilisation",
  "settings.microsoft.preview_unavailable": "Apercu non disponible. L'endpoint backend n'est pas encore actif.",
  "settings.microsoft.no_mail_items": "Aucun email a afficher.",
  "settings.microsoft.no_drive_items": "Aucun fichier OneDrive a afficher.",
  "settings.microsoft.no_sharepoint_items": "Aucun fichier SharePoint a afficher.",
  "settings.microsoft.table.subject": "Objet",
  "settings.microsoft.table.from": "De",
  "settings.microsoft.table.received_at": "Recu",
  "settings.microsoft.table.name": "Nom",
  "settings.microsoft.table.type": "Type",
  "settings.microsoft.table.size": "Taille",
  "settings.microsoft.table.modified": "Modifie",
  "settings.microsoft.table.location": "Emplacement",
  "settings.microsoft.table.time": "Heure",
  "settings.microsoft.table.message": "Message",
  "settings.microsoft.table.scopes": "Autorisations",
  "settings.microsoft.mail_reauth_required": "Ce compte necessite une reautorisation pour charger les emails.",
  "settings.microsoft.drive_reauth_required": "Ce compte necessite une reautorisation pour charger les fichiers.",
  "settings.microsoft.reauthorize_preview": "Reautoriser",
  "settings.microsoft.mail_not_found": "Compte Microsoft introuvable. Verifiez les parametres.",
  "settings.microsoft.drive_not_found": "Drive Microsoft introuvable.",
  "settings.microsoft.table.body_preview": "Apercu",
  "settings.microsoft.table.has_attachments": "Pieces jointes",
  "settings.microsoft.table.created_by": "Cree par",
};
